module.exports = __webpack_public_path__ + "media/warranty-claim/photos-wide-angle2-06443aa1.png";